import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { API_BASE_URL } from "./utils";

const DEFAULT_META_MAP = {
  "/": {
    title: "Book Best Party Venues, Bars & Cafes in Delhi-NCR",
    description:
      "Book the best party venues, bars, cafés, and top lounges near me in Delhi-NCR. Explore options, get offers & deals with PartyWitty’s booking platform.",
    keyword:
      "party venues near me, book party places, party spots Delhi NCR, bars near me, cafés near me, lounges in Delhi, birthday venues, BYOB places, rooftop party venues, nightclubs near me, book restaurant for party, party places in Noida, clubs in Gurgaon, lounges in South Delhi, PartyWitty booking, best party venues in Delhi NCR",
  },
  "/feed": {
    title: "Party Packages | Corporate Party Places, Cocktail Party Bar, Pubs",
    description:
      "Book party packages at top venues for birthdays, cocktails, and corporate events in Delhi NCR.",
    keyword:
      "party venues near me, book party places, party spots Delhi NCR, bars near me, cafés near me, lounges in Delhi, birthday venues, BYOB places, rooftop party venues, nightclubs near me, book restaurant for party, party places in Noida, clubs in Gurgaon, lounges in South Delhi, PartyWitty booking, best party venues in Delhi NCR",
  },
  "/party-packages": {
    title: "Book Top Venues & Party Packages Deals in Delhi NCR",
    description:
      "Explore the best party packages, group party venues, and night clubs in Delhi NCR. Book your perfect party spot with Party Witty – your trusted party booking app.",
    keyword:
      "party packages, birthday party packages, bachelor party deals, corporate party packages, party deals in Noida, party deals in Delhi NCR, book party packages, affordable party packages, customized party packages, venue booking, group party packages",
  },
  "/artist-page": {
    title: "PartyWitty - Our Artists",
    description: "Explore PartyWitty's top-rated artists and performers.",
  },
  "/club-about-us": {
    title: "PartyWitty - Club About Us",
    description: "Learn more about PartyWitty and our club offerings.",
  },
  "/BookATableViewAll": {
    title: "PartyWitty - Book a Table",
    description:
      "Reserve tables instantly at clubs, bars, and restaurants with exclusive deals.",
  },
  "/events": {
    title:
      "Book Events & Celebrations in Delhi NCR – Top Venues & Deals",
    description:
      "Looking for event booking in Delhi NCR? Discover top venues, curated packages, and best deals for birthdays, weddings, and corporate events.",
    keyword:
      "event booking Delhi NCR, celebration venues,  group event booking, event venues near me, birthday celebration places, corporate event packages, book events online, top party venues Delhi NCR, PartyWitty event deals",
  },
  "/venues": {
    title: "Instant Table Booking – Deals on Clubs & Restaurants Nearby",
    description:
      "Reserve tables online at top party venues in Delhi-NCR. Get amazing offers on clubs, cafes, and restaurants with PartyWitty’s easy booking.",
    keyword:
      "table booking Delhi NCR, restaurant table reservation, club table booking, book tables online, party table booking, dining reservation Delhi, table booking for parties, PartyWitty table deals",
  },
  "/my-plan": {
    title: "Book Party Packages with Food & Drinks – Best Deals",
    description:
      "Submit your package leads and get exclusive offers on top venues.",
    keyword:
      "party packages with food and drinks,  all-inclusive party packages, group party food deals, buffet party packages,  party offers with food, PartyWitty food & drink deals",
  },
  "/package-lead-form": {
    title: "Book Party Packages with Food & Drinks – Best Deals",
    description:
      "Book party packages with food & drinks at nearby venues. Compare deals, view menus, and reserve your celebration instantly with PartyWitty.",
    keyword:
      "party packages with food and drinks,  all-inclusive party packages, group party food deals, buffet party packages,  party offers with food, PartyWitty food & drink deals",
  },
  "/table-book-form": {
    title: "Instant Party Table Booking with Best Deals | PartyWitty",
    description:
      "Submit your package leads and get exclusive offers on top venuesReserve your party table instantly with PartyWitty. Enjoy exclusive deals on food, drinks & venue bookings for birthdays, kitty parties, and more.",
    keyword:
      "instant party table booking, party table reservation, quick table booking, book party table online, table deals for parties, club table booking, restaurant table booking Delhi NCR,  best table deals, PartyWitty table booking",
  },
  "/corporate-recreation-program": {
    title:
      "Corporate Recreation Program | Employee Engagement & Team Building Activities",
    description:
      "Boost employee engagement with corporate events, team building activities, and themed parties. Party Witty helps plan impactful company events tailored for team bonding and workplace fun.",
  },

  // 👇 Add static entries for dynamic routes too
  "/add-guest": {
    title: "Add Guests | PartyWitty",
    description:
      "Add or manage guests for your party booking.",
    keyword: "add guests, party guest list, invite guests, partywitty",
  },
};

const MetaHead = () => {
  const [remoteMetaMap, setRemoteMetaMap] = useState({});

  const location = useLocation();
  const path = location?.pathname || "/";

  useEffect(() => {
    const handleFetchMeta = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/master/APIs/Web/metapage`
        );
        // Expecting an object like { "/": {...}, "/feed": {...}, ... }
        if (res?.data?.data && typeof res.data.data === "object") {
          setRemoteMetaMap(res.data.data);
        }
      } catch (e) {
        console.log(e);
      }
    };
    handleFetchMeta();
  }, []);


  useEffect(() => {
    const handleaddmeta = async () => {
      try {
        const formData = new FormData();
        formData.append(
          "page_url",
          location?.pathname ? location.pathname.replace(/^\/+/, "") : ""
        );



        const res = await axios.post(
          `${API_BASE_URL}/master/APIs/Web/saveUrlWebsite`,
          formData
        );
        // Expecting an object like { "/": {...}, "/feed": {...}, ... }
        if (res?.data?.data && typeof res.data.data === "object") {
          setRemoteMetaMap(res.data.data);
        }
      } catch (e) {
        console.log(e);
      }
    };
    handleaddmeta();
  }, [location?.pathname]);



  const mergedMetaMap = useMemo(
    () => ({ ...DEFAULT_META_MAP, ...remoteMetaMap }),
    [remoteMetaMap]
  );



  const getMetaForPath = (p) => {
    if (mergedMetaMap[p]) return mergedMetaMap[p];

    const segments = p.split("/").filter(Boolean);
    for (let i = segments.length; i >= 1; i--) {
      const candidate = "/" + segments.slice(0, i).join("/");
      if (mergedMetaMap[candidate]) return mergedMetaMap[candidate];
    }

    return {
      title: "PartyWitty",
      description: "Discover clubs, events, and party packages in Delhi NCR.",
    };
  };

  const meta = getMetaForPath(path);

   const baseUrl = "https://www.partywitty.com";

  // Create canonical URL without query params
  const canonicalUrl = `${baseUrl}${path}`;



  return (
    <Helmet>
      <title>{meta?.title}</title>
      <meta name="description" content={meta?.description} />
      {meta?.keyword && <meta name="keywords" content={meta.keyword} />}
      {/* ✅ Canonical Tag */}
      <link rel="canonical" href={canonicalUrl} />

       {/* ✅ Optional: Open Graph (for social sharing) */}
      <meta property="og:title" content={meta?.title || "PartyWitty"} />
      <meta
        property="og:description"
        content={meta?.description || "Discover clubs, events, and party experiences on PartyWitty."}
      />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={meta?.image || `${baseUrl}/assets/partywitty-preview.jpg`} />
      <meta property="og:site_name" content="PartyWitty" />

     {/* ✅ Optional: Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta?.title || "PartyWitty"} />
      <meta name="twitter:description" content={meta?.description || ""} />
      <meta name="twitter:image" content={meta?.image || `${baseUrl}/assets/partywitty-preview.jpg`} />
    </Helmet>

  );
};

export default MetaHead;
